module.exports = __webpack_public_path__ + "img/bg-section-03.49caeae8.svg";